<script>
  export default {
    name: "mfa-form",
    props: ["username", "loginCode"],
    data() {
      return {
        code: '',
        btnDisabled: false
      }
    },
    methods: {
      mfaAuth () {
        this.btnDisabled = true

        this.$api.mfaAuth({
          code: this.code,
          username: this.username,
          login_code: this.loginCode
        }).then((response) => {
          this.$store.dispatch("user/set", {username: this.username, jwt_token: response.data}).then(() => {
            this.$router.push("/admin/posts")
          })
        })
      }
    },
    mounted: function () {
      this.$refs.in.focus()
    }
  }
</script>

<template>
  <div>
    <el-form-item>
      <el-input v-model="code" placeholder="请验证MFA" v-on:keyup.enter.native="mfaAuth" ref="in"></el-input>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="mfaAuth" :disabled="this.btnDisabled">验证</el-button>
    </el-form-item>
  </div>
</template>

<style scoped>

</style>